import React from 'react';
import styled from 'styled-components';
import type { NarrativeSelection } from './FilterBar';

const ChipsRow = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: -20px 0 16px;
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 8px 14px;
  border-radius: 20px;
  border: 1px solid #99a3af;
  background: #ffffff;
  color: #2e3f50;
  font-size: 13px;
  &:hover {
    border-color: #385cac;
  }
`;

const RemoveButton = styled.button`
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  &:hover {
    color: #1d3b53;
  }
`;

interface NarrativeChipsProps {
  selections: NarrativeSelection[];
  onRemove?: (id: string) => void;
}

export default function NarrativeChips({ selections, onRemove }: NarrativeChipsProps) {
  if (selections.length < 2) {
    return null;
  }

  return (
    <ChipsRow>
      {selections.map(selection => (
        <Chip key={selection.id}>
          <span>{selection.name}</span>
          <RemoveButton type="button" aria-label={`Remove ${selection.name}`} onClick={() => onRemove?.(selection.id)}>
            ×
          </RemoveButton>
        </Chip>
      ))}
    </ChipsRow>
  );
}
